<template>
  <div>
    <div class="block">
      <span class="uppercase font-medium text-sm text-muted block tracking-wide"> Industries </span>
      <nav class="flex flex-wrap -mx-1 mt-2">
        <div class="inline-block p-1" v-for="tag in tagsWithCategoryIndustry" :key="tag.id">
          <button
            class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium text-gray-800"
            :class="[isSelectedIndustryTag(tag.id) && 'bg-gray-100']"
            @click="toggleSelectedIndustryTag(tag.id)"
          >
            {{ tag.name }}
          </button>
        </div>
      </nav>
    </div>
    <div class="block mt-4">
      <span class="uppercase font-medium text-sm text-muted block tracking-wide"> Tags </span>
      <nav v-if="selectedTags.length > 0" class="flex flex-wrap -mx-1 mt-2">
        <div class="inline-block p-1" v-for="tag in selectedTags" :key="tag.id">
          <span
            class="inline-flex rounded-full items-center py-0.5 pl-2.5 pr-1 text-sm font-medium bg-indigo-100 text-indigo-700"
          >
            {{ tag.name }}
            <button
              type="button"
              class="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-indigo-400 hover:bg-indigo-200 hover:text-indigo-500 focus:outline-none focus:bg-indigo-500 focus:text-white"
              @click="toggleSelected(tag.id)"
            >
              <span class="sr-only">Remove large option</span>
              <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
              </svg>
            </button>
          </span>
        </div>
      </nav>
      <nav class="flex flex-wrap -mx-1 mt-2">
        <div class="inline-block p-1" v-for="tag in tagsWithoutCategoryIndustry" :key="tag.id">
          <button
            class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-gray-100 text-gray-800"
            @click="toggleSelected(tag.id)"
          >
            {{ tag.name }}
          </button>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
    productTags: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedIndustryTagId: null,
      selectedTagIds: [],
    };
  },
  computed: {
    tags() {
      return this.$store.getters['ui/tags/items'];
    },
    productIndustryCategoryId() {
      return (
        Object.keys(this.$store.state.entities.tagCategories.byId).find((tagCategoryId) => {
          const category = this.$store.state.entities.tagCategories.byId[tagCategoryId];

          if (!category) {
            return false;
          }

          return category.slug === 'product-industry' && category.accountId === null;
        }) || null
      );
    },
    tagsWithCategoryIndustry() {
      return this.tags.filter((tag) => tag.tagCategoryId === this.productIndustryCategoryId);
    },
    tagsWithoutCategoryIndustry() {
      return this.tags.filter((tag) => tag.tagCategoryId !== this.productIndustryCategoryId);
    },
    availableTags() {
      return this.tags
        .filter((tag) => this.selectedTagIds.indexOf(tag.id) === -1)
        .filter((tag) => this.productTags.indexOf(tag.id) >= 0);
    },
    selectedTags() {
      return this.selectedTagIds.map((tagId) => this.$store.state.entities.tags.byId[tagId]);
    },
  },
  created() {
    this.fetchProductTags();
  },
  methods: {
    async fetchProductTags() {
      try {
        await this.$store.dispatch('ui/tags/load', {
          accountId: this.accountId,
          params: {
            filter: {
              taggable_by: 'products',
            },
            include: 'tagCategory',
          },
        });
      } catch (error) {
        //
      }
    },
    isSelected(tagId) {
      return this.selectedTagIds.indexOf(tagId) >= 0;
    },
    toggleSelected(tagId) {
      if (this.isSelected(tagId)) {
        this.selectedTagIds = [
          ...this.selectedTagIds.filter((selectedTagId) => selectedTagId !== tagId),
        ];
      } else {
        this.selectedTagIds.push(tagId);
      }

      this.updateTags();
    },
    isSelectedIndustryTag(tagId) {
      return this.selectedIndustryTagId === tagId;
    },
    toggleSelectedIndustryTag(tagId) {
      if (this.isSelectedIndustryTag(tagId)) {
        this.selectedIndustryTagId = null;
      } else {
        this.selectedIndustryTagId = tagId;
      }

      this.updateTags();
    },
    clearSelectedTags() {
      this.selectedTagIds = [];
      this.updateTags();
    },
    updateTags() {
      this.$emit('change', [...this.selectedTagIds, this.selectedIndustryTagId].filter(Boolean));
    },
  },
};
</script>
